import utils from '@src/utils/genUUID'

export const LayerTypes = {
  PBF: 'PBF',
  WMS: 'WMS',
  RASTER_IMAGE: 'RASTER_IMAGE',
  RASTER_BASEMAP: 'RASTER_BASEMAP',
  VECTOR_CIRCLE: 'circle',
  VECTOR_FILL: 'fill',
  VECTOR_LINE: 'line',
  VECTOR_TEXT: 'text',
  VECTOR_FILL_EXTRUSION: 'fill-extrusion',
  UNDEFINDED: 'UNDEFINDED'
}
export default class Layer {
  constructor () {
    this._labels = undefined
    this._label = undefined
    this._onEdit = false
    this._colorPalette = []
    this._id = utils.getUUID()
    this._name = utils.getUUID()
    this._opacity = 1
    this._paint = undefined
    this._type = LayerTypes.UNDEFINDED
    this._layoutLeft = true
    this._layoutRight = true
    this._isSelected = false
    this._deleteAble = true
  }

  get deleteAble () {
    return this._deleteAble
  }

  get isSelected () {
    return this._isSelected
  }

  set isSelected (newValue) {
    this._isSelected = newValue
  }

  get label () {
    return this._label
  }

  set label (newValue) {
    this._label = newValue
  }

  get labels () {
    return this._labels
  }

  set labels (newValue) {
    this._labels = newValue
  }

  get id () {
    return this._id
  }

  set id (newValue) {
    this._id = newValue
  }

  get name () {
    return this._name
  }

  set name (newName) {
    this._name = newName
  }

  get type () {
    return this._type
  }

  get isWMS () {
    return false
  }

  get opacity () {
    return this._opacity
  }

  set opacity (newValue) {
    this._opacity = newValue
  }

  get contrast () {
    return this._contrast
  }

  set contrast (newValue) {
    this._contrast = newValue
  }

  get brightnessMax () {
    return this._brightnessMax
  }
  get brightnessMin () {
    return this._brightnessMin
  }

  set brightnessMax (newValue) {
    this._brightnessMax = newValue
  }

  set brightnessMin (newValue) {
    this._brightnessMin = newValue
  }

  // get colorPreview () {
  //   return '#B39DDB'
  // }

  get onEdit () {
    return this._onEdit
  }

  set onEdit (newValue) {
    this._onEdit = newValue
  }

  get layoutLeft () {
    return this._layoutLeft
  }

  set layoutLeft (newValue) {
    this._layoutLeft = newValue
  }

  get layoutRight () {
    return this._layoutRight
  }

  set layoutRight (newValue) {
    this._layoutRight = newValue
  }

  get meta () {
    return this._meta
  }

  get bounds () {
    return this._bounds
  }

  set bounds (newValue) {
    this._bounds = newValue
  }

  get allowStyle () {
    return false
  }

  get allowProperties () {
    return false
  }

  get paint () {
    return this._paint
  }

  set paint (newValue) {
    this._paint = newValue
  }

  get isVector () {
    return false
  }

  get tileURL () {
    return ''
  }

  get isRaster () {
    return false
  }

  get isImage () {
    return false
  }

  get isResult () {
    return false
  }

  get mapboxOpacityKeys () {
    return []
  }

  icon (color) {
    switch (this._type) {
      case LayerTypes.RASTER_IMAGE: return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.8333 16.4333H16.4333V15.8333V4.16667V3.56667H15.8333H4.16667H3.56667V4.16667V15.8333V16.4333H4.16667H15.8333ZM3.41242 16.5876L2.99108 17.0089L3.41242 16.5876C3.21238 16.3875 3.1 16.1162 3.1 15.8333V4.16667C3.1 3.88377 3.21238 3.61246 3.41242 3.41242C3.61246 3.21238 3.88377 3.1 4.16667 3.1H15.8333C16.1162 3.1 16.3875 3.21238 16.5876 3.41242L17.0109 2.98914L16.5876 3.41242C16.7876 3.61246 16.9 3.88377 16.9 4.16667V15.8333C16.9 16.1162 16.7876 16.3875 16.5876 16.5876L17.0118 17.0118L16.5876 16.5876C16.3875 16.7876 16.1162 16.9 15.8333 16.9H4.16667C3.88377 16.9 3.61246 16.7876 3.41242 16.5876ZM6.64467 13.5667L7.72329 12.1821L8.87317 13.5667H6.64467ZM11.6255 11.2298L13.3818 13.5667H9.81012L9.81549 13.5598L11.6255 11.2298Z" fill="#44C87C" stroke="#44C87C" stroke-width="1.2"/>
        </svg>`
      case LayerTypes.RASTER_BASEMAP: return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.3461 14.6765L14.6642 15.6554L15.3592 14.8962C16.5389 13.6076 17.2667 11.8898 17.2667 9.99935C17.2667 6.94638 15.3853 4.3395 12.7242 3.26779L11.9 2.93588V3.82435V4.16602C11.9 4.44891 11.7876 4.72022 11.5876 4.92026C11.3876 5.1203 11.1163 5.23268 10.8334 5.23268H9.16669H8.56669V5.83268V7.49935C8.56669 7.56123 8.5421 7.62058 8.49835 7.66434C8.45459 7.7081 8.39524 7.73268 8.33335 7.73268H6.66669H6.06669V8.33268V9.99935V10.2175L3.93262 8.08342L3.16482 7.31562L2.92338 8.37427C2.80666 8.886 2.73335 9.43111 2.73335 9.99935C2.73335 13.7061 5.50455 16.758 9.09282 17.2031L9.76669 17.2867V16.6077V14.9993V14.3993H9.16669C8.88379 14.3993 8.61248 14.287 8.41244 14.0869C8.2124 13.8869 8.10002 13.6156 8.10002 13.3327V12.4993V12.2508L7.92428 12.0751L6.44855 10.5993H6.66669H11.6667C11.7286 10.5993 11.7879 10.6239 11.8317 10.6677C11.8754 10.7115 11.9 10.7708 11.9 10.8327V13.3327V13.9327H12.5H13.3334C13.802 13.9327 14.2056 14.2443 14.3461 14.6765ZM7.0406 2.85468C7.97885 2.46604 8.98446 2.26602 10 2.26602C11.0156 2.26602 12.0212 2.46604 12.9594 2.85468C13.8977 3.24332 14.7502 3.81295 15.4683 4.53106C16.1864 5.24916 16.7561 6.10168 17.1447 7.03993C17.5333 7.97818 17.7334 8.98379 17.7334 9.99935C17.7334 12.0504 16.9186 14.0174 15.4683 15.4676C14.018 16.9179 12.051 17.7327 10 17.7327C8.98446 17.7327 7.97885 17.5327 7.0406 17.144C6.10235 16.7554 5.24983 16.1857 4.53173 15.4676C3.08145 14.0174 2.26669 12.0504 2.26669 9.99935C2.26669 7.94834 3.08145 5.98134 4.53173 4.53106C5.24983 3.81295 6.10235 3.24332 7.0406 2.85468Z" fill="#8CB9DC" stroke="#8CB9DC" stroke-width="1.2"/>
        </svg>`
      case LayerTypes.VECTOR_FILL: return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.4061 2.5809C12.1476 2.46598 11.8524 2.46598 11.5939 2.5809L3.25609 6.28658C2.46427 6.6385 2.46427 7.76228 3.25609 8.1142L11.5939 11.8199C11.8524 11.9348 12.1476 11.9348 12.4061 11.8199L20.7439 8.1142C21.5358 7.76228 21.5358 6.6385 20.7439 6.28658L12.4061 2.5809Z" stroke="${color}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.20001 18.5996L11.6004 21.8255C11.8552 21.9366 12.1448 21.9366 12.3996 21.8255L19.8 18.5996" stroke="${color}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.79999 13.7998L11.6154 16.6395C11.8615 16.7421 12.1384 16.7421 12.3846 16.6395L19.2 13.7998" stroke="${color}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`
      case LayerTypes.VECTOR_LINE: return `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.2 4.7998L4.80001 11.1998" stroke="${color}" stroke-width="1.2" stroke-linecap="round"/>
        <path d="M14.5162 3.71137C13.7918 4.21735 12.7944 4.04032 12.2884 3.31597C11.7825 2.59161 11.9595 1.59422 12.6838 1.08824C13.4082 0.582257 14.4056 0.759285 14.9116 1.48364C15.4175 2.208 15.2405 3.20539 14.5162 3.71137Z" fill="${color}"/>
        <path d="M3.31615 14.9116C2.59179 15.4175 1.59441 15.2405 1.08842 14.5162C0.58244 13.7918 0.759468 12.7944 1.48383 12.2884C2.20818 11.7825 3.20557 11.9595 3.71155 12.6838C4.21754 13.4082 4.04051 14.4056 3.31615 14.9116Z" fill="${color}"/>
        </svg>`
      case LayerTypes.VECTOR_TEXT:
      case LayerTypes.VECTOR_CIRCLE: return `<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9.99999" cy="9.99935" r="7.58333" fill="white" stroke="${color}" stroke-width="1.5"/>
        <circle cx="10" cy="10" r="5" fill="${color}"/>
        </svg>`
      default: return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.4061 2.5809C12.1476 2.46598 11.8524 2.46598 11.5939 2.5809L3.25609 6.28658C2.46427 6.6385 2.46427 7.76228 3.25609 8.1142L11.5939 11.8199C11.8524 11.9348 12.1476 11.9348 12.4061 11.8199L20.7439 8.1142C21.5358 7.76228 21.5358 6.6385 20.7439 6.28658L12.4061 2.5809Z" stroke="${color}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.20001 18.5996L11.6004 21.8255C11.8552 21.9366 12.1448 21.9366 12.3996 21.8255L19.8 18.5996" stroke="${color}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.79999 13.7998L11.6154 16.6395C11.8615 16.7421 12.1384 16.7421 12.3846 16.6395L19.2 13.7998" stroke="${color}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/layer.js